const pathOnboarding = "/cb-thirdpillar/";

export const OnboardingFullSteps = 8;
export const pagesWithProgressBarFull = [
  { page: pathOnboarding + "PersonalData", step: 1 },
  { page: pathOnboarding + "PersonalDataAdditional", step: 2 },
  { page: pathOnboarding + "Address", step: 3 },
  { page: pathOnboarding + "EmploymentDetails", step: 4 },
  { page: pathOnboarding + "InformationRecap", step: 5 },
  { page: pathOnboarding + "ContractView", step: 6 },
  { page: pathOnboarding + "VideoIdentification", step: 7 },
  { page: pathOnboarding + "SuccessVideoId", step: 8 },
  { page: pathOnboarding + "FailureVideoId", step: 8 },
  { page: pathOnboarding + "VideoIdentificationUnavailable", step: 8 },
];

export const OnboardingLightSteps = 9;
export const pagesWithProgressBarLight = [
  { page: pathOnboarding + "EmploymentDetails", step: 3 },
  { page: pathOnboarding + "InformationRecap", step: 9 },
  { page: pathOnboarding + "VideoIdentificationCs", step: 8 },
  { page: pathOnboarding + "SuccessVideoId", step: 9 },
];

export const pagesWithBackButton = [
  pathOnboarding + "PersonalDataAdditional",
  pathOnboarding + "Address",
  pathOnboarding + "EmploymentDetails",
  pathOnboarding + "InformationRecap",
];

export const CrossSellingPagesWithBackButton = [
  pathOnboarding + "Address",
  pathOnboarding + "EmploymentDetails",
  pathOnboarding + "InformationRecap",
];
